import { render, staticRenderFns } from "./CohortEditTabInformation.vue?vue&type=template&id=07edb800&scoped=true&"
import script from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07edb800",
  null
  
)

export default component.exports